export default __webpack_public_path__ + "static/media/Front-Fomatex.b57fe97f.jpg";